import React, { useEffect } from "react";
import ExploreMusicAll from "../../Components/explore/Youtube";
import NavbarMusic from "../../Components/Navbar";

const PageEksplore = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="font-signika">
      <NavbarMusic />
      <div>
        <ExploreMusicAll />
      </div>
    </div>
  );
};

export default PageEksplore;
